var _defs, _rect, _g, _rect2, _rect3, _rect4, _path, _path2, _g2, _rect5, _rect6, _rect7, _rect8, _g3, _g4, _path3, _path4, _path5, _use, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgController(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    fit: "",
    height: "100%",
    width: "100%",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: 0
  }, /*#__PURE__*/React.createElement("linearGradient", {
    y1: 14,
    x2: 0,
    y2: 34,
    id: "K",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "a",
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "b",
    offset: 1,
    stopColor: "#eee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y1: 19,
    x2: 0,
    y2: 6,
    id: "L",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "c",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "d",
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "M"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 18,
    rx: 1,
    x: 13,
    y: 1,
    id: "e",
    opacity: 0.4,
    fill: "url(#L)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 20,
    rx: 1,
    x: 2,
    y: 15,
    id: 1,
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#M)",
    id: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.53125,1.78125 A 0.85951095,0.85951095 0 0 0 15,3.03125 c 1.735311,3.1197254 4.044981,6.4862329 5.25,9.1875 0.60251,1.350634 0.889211,2.519237 0.8125,3.3125 -0.07671,0.793263 -0.344792,1.244167 -1.375,1.65625 A 0.85951095,0.85951095 0 0 0 20,18.875 l 5,0 A 0.85951095,0.85951095 0 0 0 25.875,18 c 0,-3.477458 -2.657966,-7.217111 -4.25,-10.15625 C 20.828983,6.3741803 20.348198,5.0672816 20.375,4.53125 20.388401,4.2632342 20.414916,4.2412865 20.59375,4.125 20.772584,4.0087135 21.217081,3.875 22,3.875 a 0.85994299,0.85994299 0 0 0 0.0625,-1.71875 l -6.25,-0.375 a 0.85951095,0.85951095 0 0 0 -0.28125,0 z",
    id: "N"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20,18 C 25,16 19.170667,8.7401901 15.762895,2.6137322 L 22,3 c -7,0 3,9 3,15 z",
    id: "O",
    fill: "#6a6a6a"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 20,
    rx: 1,
    x: 2,
    y: 14,
    id: 3,
    fill: "url(#K)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 15,
    rx: 1,
    x: 4,
    y: 18,
    id: 4,
    opacity: 0.839,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 15,
    rx: 1,
    x: 4,
    y: 17,
    id: 5,
    opacity: 0.839,
    fill: "#171717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 9,22 c -0.554,0 -1,0.446 -1,1 l 0,2 -2,0 c -0.554,0 -1,0.446 -1,1 l 0,2 c 0,0.554 0.446,1 1,1 l 2,0 0,2 c 0,0.554 0.446,1 1,1 l 2,0 c 0.554,0 1,-0.446 1,-1 l 0,-2 2,0 c 0.554,0 1,-0.446 1,-1 l 0,-2 c 0,-0.554 -0.446,-1 -1,-1 l -2,0 0,-2 c 0,-0.554 -0.446,-1 -1,-1 l -2,0 z m 9,5 c -0.554,0 -1,0.446 -1,1 l 0,2 c 0,0.554 0.446,1 1,1 l 9,0 c 0.554,0 1,-0.446 1,-1 l 0,-2 c 0,-0.554 -0.446,-1 -1,-1 l -9,0 z m 13,0 c -0.554,0 -1,0.446 -1,1 l 0,3 c 0,0.554 0.446,1 1,1 l 3,0 c 0.554,0 1,-0.446 1,-1 l 0,-3 c 0,-0.554 -0.446,-1 -1,-1 l -3,0 z m 6,0 c -0.554,0 -1,0.446 -1,1 l 0,3 c 0,0.554 0.446,1 1,1 l 3,0 c 0.554,0 1,-0.446 1,-1 l 0,-3 c 0,-0.554 -0.446,-1 -1,-1 l -3,0 z",
    id: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 9,21 c -0.554,0 -1,0.446 -1,1 l 0,2 -2,0 c -0.554,0 -1,0.446 -1,1 l 0,2 c 0,0.554 0.446,1 1,1 l 2,0 0,2 c 0,0.554 0.446,1 1,1 l 2,0 c 0.554,0 1,-0.446 1,-1 l 0,-2 2,0 c 0.554,0 1,-0.446 1,-1 l 0,-2 c 0,-0.554 -0.446,-1 -1,-1 l -2,0 0,-2 c 0,-0.554 -0.446,-1 -1,-1 l -2,0 z m 9,5 c -0.554,0 -1,0.446 -1,1 l 0,2 c 0,0.554 0.446,1 1,1 l 9,0 c 0.554,0 1,-0.446 1,-1 l 0,-2 c 0,-0.554 -0.446,-1 -1,-1 l -9,0 z m 13,0 c -0.554,0 -1,0.446 -1,1 l 0,3 c 0,0.554 0.446,1 1,1 l 3,0 c 0.554,0 1,-0.446 1,-1 l 0,-3 c 0,-0.554 -0.446,-1 -1,-1 l -3,0 z m 6,0 c -0.554,0 -1,0.446 -1,1 l 0,3 c 0,0.554 0.446,1 1,1 l 3,0 c 0.554,0 1,-0.446 1,-1 l 0,-3 c 0,-0.554 -0.446,-1 -1,-1 l -3,0 z",
    id: 7,
    fill: "#ebebeb"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: 8,
    fill: "#171717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 8,
    rx: 0.8,
    x: 25,
    y: -14,
    transform: "matrix(0,1,-1,0,0,0)",
    id: "P"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 8,
    rx: 0.8,
    x: -11,
    y: -30,
    transform: "scale(-1,-1)",
    id: "Q"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    rx: 0.8,
    x: 18,
    y: 28,
    id: 9,
    opacity: 0.7,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    rx: 0.8,
    x: 18,
    y: 27,
    id: "A",
    fill: "#171717"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    rx: 0.8,
    x: 23,
    y: 28,
    id: "B",
    opacity: 0.7,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    rx: 0.8,
    x: 23,
    y: 27,
    id: "C",
    fill: "#171717"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "D",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 2,
    rx: 0.8,
    x: 17,
    y: 23,
    id: "R",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 2,
    rx: 0.8,
    x: 17,
    y: 20,
    id: "S",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 2,
    rx: 0.8,
    x: 17,
    y: 17,
    id: "T",
    opacity: 0.4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "E",
    fill: "#d02604"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 31,20 h 1 v 2 h -1 z",
    id: "U"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32,21 h 1 v 1 h -1 z",
    id: "V"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 34,20 h 1 v 2 h -1 z",
    id: "W"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36,21 h 1 v 1 h -1 z",
    id: "X"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37,20 h 1 v 2 h -1 z",
    id: "Y"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39,20 h 1 v 1 h -1 z",
    id: "Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 3,14.53125 c -0.2622762,0 -0.46875,0.206474 -0.46875,0.46875 l 0,18 c 0,0.262276 0.2064738,0.46875 0.46875,0.46875 l 42,0 c 0.262276,0 0.46875,-0.206474 0.46875,-0.46875 l 0,-18 c 0,-0.262276 -0.206474,-0.46875 -0.46875,-0.46875 l -42,0 z",
    id: "F",
    opacity: 0.3,
    fill: "none",
    stroke: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 3,15 h 42 v 1 H 3 z",
    id: "G",
    opacity: 0.8,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 34,28.5 a 1.5,1.5 0 1 1 -3,0 1.5,1.5 0 1 1 3,0 z",
    id: "H",
    fill: "#d02604"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "translate(6,0)",
    id: "I",
    width: 1,
    height: 1,
    xlinkHref: "#H"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m 17,31.0594 h 11 v 0.8092 H 17 z",
    id: "J",
    opacity: 0.4,
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgController);
export default __webpack_public_path__ + "static/media/controller.bc281b9fe685e902edde5a7a06500daa.svg";
export { ForwardRef as ReactComponent };